module.exports = __webpack_public_path__ + "static/media/home-section1-bg-min.34ca6331.png";